// Convenience protection only: media displayed by the app can still be copied.
export function preventMediaAction(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    // Images ignore pointer events, so the event can target their wrapper.
    // Keep context menus in text fields and word dragging in exercises working.
    if (target.closest('input, textarea, [contenteditable="true"]')) return;
    if (target.closest('img, video, [data-protected-media]') ||
        target.querySelector(':scope > img, :scope > video') ||
        target.closest('a')?.querySelector('img, video')) {
        event.preventDefault();
    }
}
